'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';

import routing from './oauth.routes.js';
import oauthlogin from './oauthlogin/index.js';
import oauthauthorize from './oauthauthorize/index.js';

export default angular.module('georgeApp.accountoauth',
  [uiRouter, oauthlogin, oauthauthorize])
  .config(routing)
  .name;
